<div class="main-container">
    <ng-container *ngIf="bannerData$ | async as banner">
        <div class="banner-image-wrapper">
          <img [src]="getImageUrl(banner.media)" alt="Flu360 Banner" class="banner-image" />
        </div>
        <div class="text-wrapper">
            <h2 class="banner-headline" [innerHTML]="banner.headline"></h2>
            <div [innerHTML]="banner.content"></div>
        </div>
    </ng-container>
</div>

